import { create } from 'zustand';
import { PaymentStatusParams } from '@/bridge/types/payment';
import { GetPromotionsDataType } from '@/components/Ad/Promotions/PromotionFlow.helpers.types';

interface PaymentStatusModalStore {
  isWebViewPaymentModalOpen: boolean;
  webViewPaymentModalData: PaymentStatusParams | null;
  openWebViewPaymentModal: (paymentData: PaymentStatusParams) => void;
  closeWebViewPaymentModal: () => void;
  isSuccessPaymentModalOpen: boolean;
  setIsSuccessPaymentModalOpen: (isOpen: boolean) => void;
  isInvoicePaymentSuccessModalOpen: boolean;
  setIsInvoicePaymentSuccessModalOpen: (isOpen: boolean) => void;
  successPaymentModalData: GetPromotionsDataType | null;
  setSuccessPaymentModalData: (paymentData: GetPromotionsDataType) => void;
}

export const usePaymentStatusModalStore = create<PaymentStatusModalStore>(
  set => ({
    isWebViewPaymentModalOpen: false,
    webViewPaymentModalData: null,
    openWebViewPaymentModal: paymentData =>
      set({
        isWebViewPaymentModalOpen: true,
        webViewPaymentModalData: paymentData,
      }),
    closeWebViewPaymentModal: () => set({ isWebViewPaymentModalOpen: false }),
    isSuccessPaymentModalOpen: false,
    isInvoicePaymentSuccessModalOpen: false,
    successPaymentModalData: null,
    setIsSuccessPaymentModalOpen: (isOpen: boolean) =>
      set({ isSuccessPaymentModalOpen: isOpen }),
    setIsInvoicePaymentSuccessModalOpen: (isOpen: boolean) =>
      set({ isInvoicePaymentSuccessModalOpen: isOpen }),
    setSuccessPaymentModalData: (paymentData: GetPromotionsDataType) =>
      set({ successPaymentModalData: paymentData }),
  })
);
